import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { filter, firstValueFrom, take } from 'rxjs';
import { AuthGuard } from './auth.guard';
import { UserPermissionsService } from '../services/user-permissions.service';

@Injectable({ providedIn: 'root' })
export class AuditTrailGuard implements CanActivate {
  private readonly authGuard = inject(AuthGuard);
  private readonly permissions = inject(UserPermissionsService);
  private readonly router = inject(Router);
  private readonly permissionsLoaded$ = toObservable(this.permissions.permissionsLoaded);

  async canActivate(): Promise<boolean | UrlTree> {
    const authenticated = await this.authGuard.canActivate();
    if (authenticated !== true) {
      return authenticated;
    }

    if (!this.permissions.permissionsLoaded()) {
      await firstValueFrom(
        this.permissionsLoaded$.pipe(
          filter(() => this.permissions.permissionsLoaded()),
          take(1),
        ),
      );
    }

    return this.permissions.canAccessAuditTrail()
      ? true
      : this.router.createUrlTree(['/access-denied']);
  }
}
